export const contingentCloseIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path d="M16 2L2 16M16 16L2 2" stroke="#DFF0FA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/></svg>`,
  name: 'close',
};
